export default "__VITE_ASSET__Qyy0eRe3__"